import { Box, IconButton, Stack, Switch, useMediaQuery } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import AppLayout from "../componets/AppLayout/AppLayout";
import { DataGrid } from "@mui/x-data-grid";
import { MembershipAPI } from "../api/membership";
import { Link, useNavigate } from "react-router-dom";
import VisibilityIcon from "../assets/SVGs/Login/VisibilityIcon";
import { filterArrayByString } from "../componets/helper";
import AddMemeberModal from "../componets/Modal/AddMemeberModal";
import GridCustomHeader from "../componets/AppLayout/GridCustomHeader";
import dayjs from "dayjs";
import { useAppContext } from "../context/AppContext";
import { DatePicker } from "@mui/x-date-pickers";
import ReportModal from "../componets/Modal/ReportModal";
import { useAuth } from "../context/AuthContext";

const Membership = () => {
  const { openSnack } = useAppContext();
  const { user } = useAuth();
  const role = user?.role;
  const isMember = role === "MEMBER";
  const isMobileTable = useMediaQuery("(max-width:850px)");

  const [listings, setListings] = useState([]);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openReportModal, setOpenReportModal] = useState(false);
  const [statusFilter, setStatusFilter] = useState("active");

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const baseColumns = [
    {
      field: "first_name",
      headerName: "First Name",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
    },
    {
      field: "company",
      headerName: "Company",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
    },
    {
      field: "email_address",
      headerName: "Email Address",
      flex: 1,
      minWidth: isMobileTable ? 200 : undefined,
      editable: true,
    },
    {
      field: "phone_number",
      headerName: "Phone No.",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
    },
    {
      field: "chair",
      headerName: "Chair",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
    },
    {
      field: "date_started",
      headerName: "Date Started",
      flex: 1,
      minWidth: isMobileTable ? 150 : undefined,
      editable: true,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate();
      },
      renderCell: (params) => {
        return params?.value ? dayjs(params?.value).format("MM/DD/YYYY") : "";
      },
      renderEditCell: (params) => {
        const handleChange = (newValue) => {
          params.api.setEditCellValue({
            id: params.id,
            field: "date_started",
            value: dayjs(newValue).format("YYYY-MM-DD"),
          });
        };

        return (
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={handleChange}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "date_started",
                name: "date_started",
                className: "login-textField",
                size: "small",
              },
            }}
          />
        );
      },
    },
    {
      field: "dues_paid",
      headerName: "Dues Paid",
      flex: 1,
      editable: true,
      minWidth: isMobileTable ? 150 : undefined,
      valueGetter: (params) => {
        return params ? "Yes" : "No";
      },
      renderCell: (params) => {
        return params.value === "Yes" ? "Yes" : "No";
      },
      renderEditCell: (params) => {
        const handleChange = (event) => {
          const newValue = event.target.checked;
          params.api.setEditCellValue({
            id: params.id,
            field: "dues_paid",
            value: newValue,
          });
        };

        return (
          <Switch
            checked={Boolean(params.value)}
            onChange={handleChange}
            inputProps={{ "aria-label": "Dues Paid Checkbox" }}
            className="switchStyles"
          />
        );
      },
    },
    {
      field: "membership_expiration_date",
      headerName: "Expiration",
      flex: 1,
      editable: true,
      minWidth: isMobileTable ? 150 : undefined,
      type: "date",
      valueGetter: (params) => {
        return dayjs(params).toDate();
      },
      renderCell: (params) => {
        return params.value ? dayjs(params.value).format("MM/DD/YYYY") : "";
      },
      renderEditCell: (params) => {
        const handleChange = (event) => {
          const newValue = event;
          params.api.setEditCellValue({
            id: params.id,
            field: "membership_expiration_date",
            value: dayjs(newValue).format("YYYY-MM-DD"),
          });
        };

        return (
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={handleChange}
            format="MM/DD/YYYY"
            slotProps={{
              textField: {
                margin: "normal",
                fullWidth: true,
                id: "membership_expiration_date",
                name: "membership_expiration_date",
                className: "login-textField",
                size: "small",
              },
            }}
          />
        );
      },
    },
  ];

  const actionsColumn = {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 100,
    maxWidth: 100,
    filterable: false,
    sortable: false,
    renderCell: (params) => (
      <IconButton aria-label="view" size="small">
        <Link
          to={`/membership/${params.row.id}`}
          className="flex items-center justify-center"
        >
          <VisibilityIcon
            sx={{
              color: "#64748B",
            }}
          />
        </Link>
      </IconButton>
    ),
  };

  const adminOnlyFields = ["dues_paid", "membership_expiration_date"];
  const columns = isMember
    ? baseColumns.filter((col) => !adminOnlyFields.includes(col.field))
    : [...baseColumns, actionsColumn];

  const handleSearch = (searchString) => {
    setSearchText(searchString);
  };

  const handleStatusChange = (newStatus) => {
    setStatusFilter(newStatus);
    setIsLoading(true);
  };

  const fetchMembers = useCallback(async () => {
    setIsLoading(true);
    try {
      const fetchFn = isMember
        ? MembershipAPI.getMemberDirectory
        : MembershipAPI.getMembers;
      setListings(await fetchFn(statusFilter));
    } catch (e) {
      const status = e.response?.status;
      if (status === 401) {
        navigate("/login");
      }
      console.error("Error during fetching report", e);
    } finally {
      setIsLoading(false);
    }
  }, [statusFilter, navigate, isMember]);

  useEffect(() => {
    if (isLoading) {
      fetchMembers();
    }
  }, [isLoading, fetchMembers]);

  const editMember = async (form) => {
    const member = {
      ...form,
      dues_paid_amount: form.dues_paid_amount * 1,
      date_started: dayjs(form.date_started).format("YYYY-MM-DD"),
      membership_expiration_date: dayjs(form.membership_expiration_date).format(
        "YYYY-MM-DD",
      ),
      dues_paid_date: dayjs(form.dues_paid_date).format("YYYY-MM-DD"),
    };
    delete member?.id;
    delete member?.dues_paid_date;
    try {
      await MembershipAPI.updateMember(member, form.id);
      fetchMembers();
      openSnack("Member information updated successfully.");
    } catch (error) {
      openSnack("Error updating member.", "error");
      throw error;
    }
  };

  const processRowUpdate = async (newRow, oldRow) => {
    try {
      await editMember(newRow);
      return newRow;
    } catch (error) {
      console.error("Row update failed:", error);
      return oldRow;
    }
  };

  const getRowsData = () => {
    const dummyRows = [...(listings?.items || [])];
    return filterArrayByString(dummyRows || [], searchText);
  };

  return (
    <AppLayout>
      <Box
        sx={{
          width: "100%",
          padding: isMobileTable ? "8px" : "24px",
        }}
      >
        <GridCustomHeader
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          searchText={searchText}
          handleSearch={handleSearch}
          setOpenModal={setOpenModal}
          open={open}
          handleClick={handleClick}
          handleClose={handleClose}
          anchorEl={anchorEl}
          buttonText="Add New Member"
          moreOptions
          setOpenReportModal={setOpenReportModal}
          status={statusFilter}
          onStatusChange={handleStatusChange}
          role={role}
          showStatusSwitch
        />

        <Stack
          sx={{
            width: "100%",
            overflowX: "hidden",
          }}
          className="customDataGridFigma"
        >
          <DataGrid
            rows={getRowsData() || []}
            columns={columns}
            loading={isLoading}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 20 },
              },
            }}
            disableVirtualization
            processRowUpdate={processRowUpdate}
            pageSizeOptions={[10, 15, 20, 25]}
            checkboxSelection={false}
            rowSelection={false}
            rowHeight={48}
            columnHeaderHeight={40}
            getRowClassName={(params) => {
              const customClassName =
                params.indexRelativeToCurrentPage % 2 !== 0 ? "bg-gray" : "";
              return `${customClassName}`.trim();
            }}
            slotProps={{
              loadingOverlay: {
                variant: "linear-progress",
                noRowsVariant: "linear-progress",
              },
            }}
            localeText={{
              noRowsLabel: "No members found.",
            }}
          />
        </Stack>

        {!isMember && openModal && (
          <AddMemeberModal
            open={openModal}
            handleClose={() => setOpenModal(false)}
            setIsLoading={setIsLoading}
          />
        )}

        {openReportModal?.open && (
          <ReportModal
            open={openReportModal?.open}
            handleClose={() => setOpenReportModal({})}
            showAllTime={openReportModal?.showAllTime}
            generalClosedBusiness={openReportModal?.generalClosedBusiness}
            overallActivity={openReportModal?.overallActivity}
            title={
              openReportModal?.overallActivity
                ? "Overall Activity Report"
                : openReportModal?.generalClosedBusiness
                  ? "Closed Business Report"
                  : undefined
            }
          />
        )}
      </Box>
    </AppLayout>
  );
};

export default Membership;
